import { createSlice } from '@reduxjs/toolkit';
import { addItemToCartThunk, getCartDetailsThunk, getCartInfoThunk, getCartListThunk, getCartPriceDetailsThunk, getFinalPriceDetailsThunk, getOrderDetailsThunk, getOrderListThunk, getOrderTransationDetailsThunk, getOrderTransationListThunk, getOrderTransationThunk } from '../thunks/orderThunk';
import { toast } from 'react-toastify';

const orderSlice = createSlice({
  name: 'order',
  initialState: {
    cartList: "",
    cartDetails: "",
    cartInfo: "",
    cartPriceDetails: '',
    finalPriceDetails: '',
    orderList: '',
    orderDetails: '',
    transactionList: '',
    transactionDetails: ''
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCartListThunk.fulfilled, (state, action) => {
        state.cartList = action.payload?.data;
      })
      .addCase(getCartDetailsThunk.fulfilled, (state, action) => {
        state.cartDetails = action.payload?.data;
      })
      .addCase(getCartPriceDetailsThunk.fulfilled, (state, action) => {
        state.cartPriceDetails = action.payload?.data;
      })
      .addCase(getFinalPriceDetailsThunk.fulfilled, (state, action) => {
        state.finalPriceDetails = action.payload?.data;
      })
      .addCase(getFinalPriceDetailsThunk.rejected, (state, action) => {
        state.finalPriceDetails = '';
      })
      .addCase(addItemToCartThunk.rejected, (state, action) => {

        toast.error(action?.payload?.message)
      })
      .addCase(getOrderListThunk.fulfilled, (state, action) => {
        state.orderList = action.payload?.data;
      })
      .addCase(getOrderDetailsThunk.fulfilled, (state, action) => {
        state.orderDetails = action.payload?.data;
      })
      .addCase(getOrderTransationListThunk.fulfilled, (state, action) => {
        state.transactionList = action.payload?.data;
      })
      .addCase(getOrderTransationDetailsThunk.fulfilled, (state, action) => {
        state.transactionDetails = action.payload?.data;
      })
      .addCase(getCartInfoThunk.fulfilled, (state, action) => {
        state.cartInfo = action.payload?.data;
      })

  },
});

// export const { logout } = userSlice.actions;

export default orderSlice.reducer;
